module.exports = __webpack_public_path__ + "img/api-1.f53cf5f2.png";